import { Component, OnInit } from '@angular/core';
import { CtrlBaseComponent } from '../ctrl-base.component';
import { Color } from '../../enums/color.enum';

@Component({
  selector: 'ct-anchor',
  templateUrl: './ct-anchor.component.html',
  styleUrls: ['./ct-anchor.component.css']
})
export class CtAnchorComponent extends CtrlBaseComponent implements OnInit {

  private text : string;
  private link : string;
  private hoverColor : Color;
  private textColor : Color;
  private isNewTab : boolean;
  
  //util
  public Color = Color;

  constructor() { 
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  public setLink(link : string) : void { this.link = link; }
  public setIsNewTab(isNewTab : boolean) : void { this.isNewTab = isNewTab; }
  public setText(text : string) : void { this.text = text; }
  public setHoverColor(hoverColor : Color) : void { this.hoverColor = hoverColor; }
  public setTextColor(textColor : Color) : void { this.textColor = textColor; }

  public getLink() : string { return this.link; }
  public getIsNewTab() : boolean { return this.isNewTab; }
  public getText() : string { return this.text; }
  public getHoverColor() : Color { return this.hoverColor; }
  public getTextColor() : Color { return this.textColor; }
}